import { render, staticRenderFns } from "./IconPaperClipOutline.vue?vue&type=template&id=43287a4f"
import script from "./IconPaperClipOutline.vue?vue&type=script&lang=js"
export * from "./IconPaperClipOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports